// extracted by mini-css-extract-plugin
export default {"DistributionHistoryContent":"DistributionHistory_DistributionHistoryContent__R48Gd","composeBoxEmpty":"DistributionHistory_composeBoxEmpty__kWPpv"};